'use strict';

/**
 * A directive that scrolls an element in sections, smoothly, making use of Tween.js (https://github.com/tweenjs/tween.js).
 *
 * This directive [ms-smooth-scroll] gets defined on the container designed to scroll,
 * and [ms-smooth-scroll-section] on the child sections.
 *
 * Pass the index of the section you wish to scroll to, and this directive will scroll to it.
 * Works with both vertical scrolling or horizontal scrolling, but all the sections must have the same dimentions.
 *
 */
(function () {
  'use strict';

  angular.module('msUtility').directive('msSmoothScroll', msSmoothScrollDir);

  msSmoothScrollDir.$inject = ['msSmoothScroll'];

  /* @ngInject */
  function msSmoothScrollDir(msSmoothScroll) {
    var directive = {
      link: link,
      restrict: 'A',
      scope: false
    };
    return directive;

    function link(scope, element, attrs) {
      attrs.$observe('msSmoothScroll', function (newIndex) {
        doScrollOffset(newIndex);

        // Re-calc offset on window resize
        window.addEventListener('resize', function () {
          doScrollOffset(newIndex);
        });

        // Preforms the scroll offset for a smooth scroll section
        function doScrollOffset(newIndex) {
          // Collect the sections that will be scrolled to.
          var sections = element[0].querySelectorAll('[ms-smooth-scroll-section]');
          var thisSection = angular.element(sections[newIndex]);

          // If the new index does not match the index of an existing section, don't do anything.
          if (_.isUndefined(sections[newIndex])) {
            return;
          }

          // Calculate the total distance to scroll by.
          // This calculation makes the assumption that each section has the same width and height.
          var offsetWidth = (thisSection[0].offsetWidth + parseInt(thisSection.css('marginRight'))) * newIndex;
          var offsetHeight = (thisSection[0].offsetHeight + parseInt(thisSection.css('marginBottom'))) * newIndex;

          msSmoothScroll.scrollTo(element, offsetWidth, offsetHeight);
        }
      });

      scope.$on('$destroy', function () {
        TWEEN.getAll().forEach(function (tween) {
          return tween.stop();
        });
      });
    }
  }
})();